export default function(mobileBreakPoint, callback) {
  (function($) {
    if (typeof callback !== "function" || !mobileBreakPoint) {
      return;
    }

    var $win = $(window);

    var mobileView = false;

    $win.resize(function() {
      if ($win.width() < mobileBreakPoint && !mobileView) {
        mobileView = true;
        callback(mobileView);
      } else if ($win.width() >= mobileBreakPoint && mobileView) {
        mobileView = false;
        callback(mobileView);
      }
    });

    if ($win.width() < mobileBreakPoint) {
      mobileView = true;
    } else if ($win.width() >= mobileBreakPoint) {
      mobileView = false;
    }

    callback(mobileView);
  })(jQuery);
}
